export const config = {
    apiUrl: 'https://uat-tata-ms.ns-devsecops.com/api/v1',
    appVersion: '1.0.0',
};
export default config;
